import i18n from '../../../i18n';
import httpService from "../../../services/http.service";

/**
 * Actions sur un compte du back-office, partagées par la liste (/moderateurs) et la fiche (/moderateurs/:id).
 * Chaque action demande confirmation, appelle l'API puis renvoie le compte mis à jour
 * (ou `null` si l'utilisateur annule ou si l'API refuse : le message d'erreur est affiché).
 */

const actionErrorMessage = (e) =>
    e?.response?.data?.message || i18n.t("Action impossible, veuillez réessayer.");

const backOfficeLink = () => `${window.location.protocol}//${window.location.hostname}`;

const run = async (confirmMessage, request) => {
    if (confirmMessage && !window.confirm(confirmMessage)) return null;
    try {
        return await request();
    } catch (e) {
        window.alert(actionErrorMessage(e));
        return null;
    }
};

/** Le compte connecté ne gère ni lui-même ni un autre root (même règle que l'API). */
export const canManage = (authUser, admin) => !!authUser?.isRoot && authUser.id !== admin.id && !admin.isRoot;

export const toggleAccount = (admin) => run(
    admin.actif ? i18n.t("Confirmer désactivation du compte ?") : i18n.t("Confirmer activation du compte ?"),
    async () => {
        await httpService.put(`/moderateurs/${admin.id}/toggle`);
        return {...admin, actif: !admin.actif, tokens_count: admin.actif ? 0 : admin.tokens_count};
    }
);

export const resetPassword = (admin) => run(
    i18n.t("Envoyer un nouveau mot de passe temporaire à {{email}} ? Ses sessions ouvertes seront fermées.", {email: admin.email}),
    async () => {
        await httpService.post(`/moderateurs/${admin.id}/reset-password`, {link: backOfficeLink()});
        window.alert(i18n.t("Mot de passe envoyé par e-mail."));
        return {...admin, tokens_count: 0};
    }
);

export const forceLogout = (admin) => run(
    i18n.t("Fermer les sessions ouvertes de {{name}} ?", {name: `${admin.nom} ${admin.prenom}`}),
    async () => {
        await httpService.post(`/moderateurs/${admin.id}/logout`);
        return {...admin, tokens_count: 0};
    }
);

export const deleteAccount = (admin) => run(
    i18n.t("Confirmer suppression du compte ?"),
    async () => {
        await httpService.delete(`/moderateurs/${admin.id}`);
        return admin;
    }
);
